import React from 'react';
import { Editor } from 'slate';
import { Plugin, CustomEditor, CustomText } from '../types';

const ItalicPlugin: Plugin = {
  name: 'italic',
  
  onKeyDown: (event: KeyboardEvent, editor: CustomEditor) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'i') {
      event.preventDefault();
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.italic === true;
      if (isActive) {
        Editor.removeMark(editor, 'italic');
      } else {
        Editor.addMark(editor, 'italic', true);
      }
      return true;
    }
    return false;
  },

  commands: {
    toggleItalic: (editor: CustomEditor) => {
      const marks = Editor.marks(editor) as CustomText;
      const isActive = marks?.italic === true;
      if (isActive) {
        Editor.removeMark(editor, 'italic');
      } else {
        Editor.addMark(editor, 'italic', true);
      }
    }
  }
};

export default ItalicPlugin; 